export default {
  data: function () {
    return {
      actions: false
    }
  },
  props: {
    area: {
      type: Object,
      require: true
    }
  },
  methods: {
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/common-area/index/components/resources/index.js